import { render } from "./statisticCard.vue?vue&type=template&id=383f66da"
import script from "./statisticCard.vue?vue&type=script&lang=js"
export * from "./statisticCard.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__